const page = 'events-events';

export default [
    {
        path: '/event',
        name: `${page}-main`,
        exact: true,
        component: () => import('@/pages/event_enhanced/Index'),
        meta: {
            auth: true,
            permission: ['sp.events.events.access','sp.events.event-templates.access'],
            title: 'Events',
            prefix: `${page}-main`,
            nimbusPageType: 'nav-landing-page'
        },
        children: [
            {
                path: `/event/event-template`,
                name: `${page}-event-templates-event`,
                exact: true,
                component: () => import('@/pages/core/events/event_templates/EventsEventTemplatesMain.vue'),
                meta: {
                    auth: true,
                    permission: ['sp.events.event-templates.access'],
                    title: 'Event Templates',
                    prefix: `${page}-event-templates-event`,
                },
            },
            {
                path: `/event/events`,
                name: `${page}-events`,
                exact: true,
                component: () => import('@/pages/event_enhanced/events/EventsMain.vue'),
                meta: {
                    auth: true,
                    permission: ['sp.events.events.access'],
                    title: 'Events',
                    prefix: `${page}-events`,
                },
            },
        ]
    },

];
